import dataFormat from './common/dataFormat';

/**
 * KLineTooltipController类定义
 */
class KLineEChartsTooltipController {
    /**
     * KLineTooltipController类构造函数
     */
    constructor() {
        this.availableHeight = 0;
        this.grids = [];
        this.gridGroups = [];
    }

    /**
     * 设置属性
     * @param {Object} tooltipDataObj tooltip数据对象
     */
    setProperty(tooltipDataObj) {
        this.availableHeight = tooltipDataObj.availableHeight || 0;
        this.grids = tooltipDataObj.grids || [];
        this.gridGroups = tooltipDataObj.gridGroups || [];
    }

    /**
     * 获取指定索引的tooltip位置
     * @param {Number} index 指定的索引
     * @returns {Object} 返回tooltip位置
     */
    getPositionByIndex(index) {
        let top = '';
        if (index > 0 && this.grids[index]) {
            let topFactor = this.grids[index].top.toString().replace('%', '');
            // 排除百分比偏差
            top = (this.availableHeight * Number(topFactor)) / 100 - 14;
            top += 'px';
        }
        return {
            top
        };
    }

    /**
     * 生成指定grid里面，所有tooltip.show不为false的series的tooltip
     * @param {Number} index 指定的grid索引
     * @param {Array<Number>} exceptSeries 要排除的series索引集合
     * @returns {Array<Object>} 返回生成的内容对象
     */
    getGridTooltipByIndex(index, exceptSeries = []) {
        let seriesGroups = this.gridGroups[index] || [];
        let results = [];
        seriesGroups.forEach(oneSeries => {
            if (exceptSeries.some(seriesIndex => seriesIndex === oneSeries.seriesIndex)) {
                return;
            }

            let name = oneSeries.seriesName;
            if (oneSeries.option.tooltip && oneSeries.option.tooltip.show === false) {
                return;
            }
            if (name === 'BOLL') {
                name = 'BOLL(20, 2) ' + name;
            }
            let value = oneSeries.value;
            if (isFinite(value)) {
                value = dataFormat.numberFormatLogic(value);
            } else {
                value = 0;
            }
            results.push({
                name,
                value
            });
        });
        return results;
    }

    /**
     * 获取价格tooltip
     * @returns {Object} 返回生成的内容对象
     */
    getPriceTooltip() {
        if (!this.gridGroups[0]) {
            return {};
        }
        let seriesGroup = this.gridGroups[0];
        let param = seriesGroup[0];
        let prices = param.data;
        let dateString = dataFormat.datetimeFormatLogic(param.axisValue);
        return {
            dateString,
            open: prices[1],
            close: prices[2],
            lowest: prices[3],
            highest: prices[4]
        };
    }

    /**
     * 获取涨幅振幅tooltip
     * @returns {Object} 返回生成的内容对象
     */
    getChangeRangeTooltip() {
        if (!this.gridGroups[0]) {
            return {};
        }
        let seriesGroups = this.gridGroups[0];
        let oneSeries = seriesGroups[0];
        let prices = oneSeries.data;
        // 如果没有前收，则用开盘价代替
        let lastClose = prices[1];
        if (oneSeries.dataIndex - 1 >= 0) {
            lastClose = oneSeries.option.data[oneSeries.dataIndex - 1][1];
        }
        let close = prices[2];
        let lowest = prices[3];
        let highest = prices[4];

        let changeRange = (close / lastClose - 1) * 100; // 涨跌幅
        let amplitude = (highest / lowest - 1) * 100; // 振幅
        if (isNaN(changeRange)) {
            changeRange = 0;
        } else {
            changeRange = dataFormat.numberFormatLogic(changeRange, 2);
        }
        if (isNaN(amplitude)) {
            amplitude = 0;
        } else {
            amplitude = dataFormat.numberFormatLogic(amplitude, 2);
        }
        return {
            changeRange,
            amplitude
        };
    }

    /**
     * 获取MarkPoint的tooltip
     * @returns {Array<Object>} 返回生成的内容对象
     */
    getMarkPointTooltip() {
        if (!this.gridGroups[0]) {
            return [];
        }
        let seriesGroups = this.gridGroups[0];
        let oneSeries = seriesGroups[0];
        let series = oneSeries.option;

        if (!series.markPoint || !(series.markPoint.data instanceof Array) || series.markPoint.data.length === 0) {
            return {};
        }

        let results = [];
        // 因为同一时间点有可能有多个markPoint
        let markPoints = series.markPoint.data;
        for (let i = 0; i < markPoints.length; i++) {
            const markPoint = markPoints[i];
            if (markPoint.coord instanceof Array && markPoint.coord[0] === oneSeries.axisValue) {
                results.push({
                    name: markPoint.name,
                    price: markPoint.coord[1],
                    count: markPoint.count
                });
            }
            // 因为markPoint是由多组markPoint拼接(concat)而成的，无法通过判断下一个点的时间是否超过指定时间来中断循环，因为后面的数据无法保证时间戳都超过当前时间戳
        }
        return results;
    }
}

export default KLineEChartsTooltipController;



// WEBPACK FOOTER //
// ./src/controller/KLineEChartsTooltip.js